import React from 'react';
import {
  GAME_THEORY_WHEEL_FORCE_MAX,
  GAME_THEORY_WHEEL_FORCE_MIN,
  GAME_THEORY_WHEEL_FORCE_STEP,
  formatString,
} from '@deadpan/shared';
import { useTranslations } from '../../hooks/useTranslations';

interface GameTheoryWheelForceSliderProps {
  value: number;
  onChange: (force: number) => void;
  disabled?: boolean;
}

export const GameTheoryWheelForceSlider: React.FC<GameTheoryWheelForceSliderProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const t = useTranslations();
  const gtw = t.games.gameTheoryWheel;
  const displayForce = value.toFixed(1);

  return (
    <div className="w-full space-y-2">
      <p className="text-sm sm:text-base font-semibold text-gray-800 text-center">
        {formatString(gtw.forceLabel, { force: displayForce })}
      </p>
      <input
        type="range"
        min={GAME_THEORY_WHEEL_FORCE_MIN}
        max={GAME_THEORY_WHEEL_FORCE_MAX}
        step={GAME_THEORY_WHEEL_FORCE_STEP}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-2 accent-indigo-600 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label={formatString(gtw.forceLabel, { force: displayForce })}
      />
      <div className="flex justify-between text-[11px] sm:text-xs text-gray-500 px-0.5">
        <span>0</span>
        <span>1</span>
        <span>2</span>
        <span>3</span>
      </div>
      <p className="text-xs text-gray-500 text-center">{gtw.degreesPerForceHint}</p>
    </div>
  );
};
